'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _omit = require('../utils/underscore/omit');

var _omit2 = _interopRequireDefault(_omit);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _UIButton = require('./UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UITooltip = require('../tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UIIconButton',

  propTypes: _extends({}, (0, _omit2.default)(_UIButton2.default.propTypes, ['block', 'responsive']), {
    children: _react.PropTypes.node,
    iconClassName: _react.PropTypes.string,
    placement: _UITooltip2.default.propTypes.placement,
    shape: _react.PropTypes.oneOf(['square', 'circle']),
    tooltip: _UITooltip2.default.propTypes.title,
    TooltipContent: _UITooltip2.default.propTypes.Content
  }),

  getDefaultProps: function getDefaultProps() {
    return _extends({}, _UIButton2.default.defaultProps, {
      block: false,
      placement: _UITooltip2.default.defaultProps.placement,
      shape: 'square',
      use: 'tertiary-light'
    });
  },
  render: function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        placement = _props.placement,
        shape = _props.shape,
        tooltip = _props.tooltip,
        TooltipContent = _props.TooltipContent,
        rest = _objectWithoutProperties(_props, ['children', 'className', 'placement', 'shape', 'tooltip', 'TooltipContent']);

    return _react2.default.createElement(
      _UITooltip2.default,
      { Content: TooltipContent, title: tooltip, placement: placement },
      _react2.default.createElement(
        _UIButton2.default,
        _extends({}, rest, {
          className: (0, _classNames2.default)('private-button--icon-only', { 'private-button--circle': shape === 'circle' }, className),
          responsive: false
        }),
        children
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/button/UIIconButton.js
// module id = 513
// module chunks = 171